// Recurring Journals — recurring_journals.* (Finance)
//
// The backend keys are registered by amer-laravel's
// `2026_09_21_000002_add_finance_close_and_control_and_department_restore_permissions.php`,
// which is live in `database/migrations/` — it left
// `pending-central-approval/` once the keys were approved (21 Sep 2026). The ids
// below are the central key service's **approval numbers**, which that migration
// writes as each permission row's own `permissions.id` — the two have to stay
// equal.
//
// An id here that does not equal its backend row id fails silently:
// `HAS_PERMISSION` simply returns false, so the page, the sidebar leaf and every
// gated button never appear, with nothing logged anywhere. Read an issued id off
// the registry; never derive the next one from the last.

/** recurring_journals.index — the register, and opening a row in it. */
export const RECURRING_JOURNALS_INDEX = 1642;

/**
 * recurring_journals.show — collapsed into `index` by the August 2026 audit, and
 * the route file says so ("A detail route is guarded by the module's `index`").
 *
 * Aliased rather than pointed at a key that does not exist: a constant naming a
 * missing key makes `HAS_PERMISSION` false forever and the record page vanishes
 * for everyone.
 */
export const RECURRING_JOURNALS_SHOW = RECURRING_JOURNALS_INDEX;

export const RECURRING_JOURNALS_CREATE = 1643;
export const RECURRING_JOURNALS_UPDATE = 1644;
export const RECURRING_JOURNALS_DELETE = 1645;

/**
 * recurring_journals.restore — deleting a journal only stops future runs, and
 * both its posted entries and its run log survive, so restoring one resumes a
 * real series rather than reviving a husk. (A deferral schedule has no restore
 * key for exactly the opposite reason.)
 */
export const RECURRING_JOURNALS_RESTORE = 1646;

/**
 * recurring_journals.run — posting the next due occurrence by hand.
 *
 * Its own key, and classified as a *create* on the backend: it writes a new
 * ledger entry and edits nothing that was already posted. Someone trusted to
 * correct a template's narration is not necessarily trusted to post with it.
 */
export const RECURRING_JOURNALS_RUN = 1617;
